import React from 'react';

import City from '../../../types/City';
import School from '../../../types/School';
import SchoolType from '../../../types/SchoolType';

import Table from '../../common/ui/Table/Table';
import TableHead from '../../common/ui/Table/Head';
import SchoolsTableRow from './TableRow';

interface Props {
  schools: School[];
  cities: Record<number, City>;
  schoolTypes: Record<number, SchoolType>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;

  sortData: { column: string; descending: boolean };
  setSortData: (data: { column: string; descending: boolean }) => void;
}

const SchoolsTable = ({
  schools,
  cities,
  schoolTypes,
  showError,
  unauthorizedCallback,
  sortData,
  setSortData,
}: Props) => {
  const schoolsRows = schools.map((school: School) => (
    <SchoolsTableRow
      key={school.id}
      school={school}
      cities={cities}
      schoolTypes={schoolTypes}
      unauthorizedCallback={unauthorizedCallback}
      showError={showError}
    />
  ));

  return (
    <Table>
      <TableHead
        columns={[
          { label: 'Название', width: '25%' },
          { label: 'Тип ОО', width: '25%' },
          { label: 'Код', width: '25%' },
          { label: 'Город', width: '25%' },
        ]}
        sortingBy={sortData.column}
        descending={sortData.descending}
        setSortData={setSortData}
      />

      <tbody>{schoolsRows}</tbody>
    </Table>
  );
};

export default SchoolsTable;
